// eslint-disable-next-line
export default {
    name: "Favorites",
    status: {
        router: true,
        redux: true
    }
}
